const colors = {
	aluminum: "#8F97A8",
	fiord: "#41516F",
	danube: "#508BC8",
	mischka: "#E4E5E9",
	alabaster: "#F9F9F9"
};
export default colors;



// WEBPACK FOOTER //
// ./src/utils/colors.js